import { z } from 'zod/v4';

export const BulkUpdateAssigneeUserSchema = z.object({
  userId: z.string().min(1),
  companyId: z.string().min(1),
});

export const BulkUpdateAssigneeRequestSchema = z
  .object({
    actionIds: z.array(z.string().min(1)).min(1),
    add: z.array(BulkUpdateAssigneeUserSchema).default([]),
    remove: z.array(BulkUpdateAssigneeUserSchema).default([]),
  })
  .refine(body => body.add.length + body.remove.length > 0, {
    message: 'Must provide at least one assignee to add or remove',
  });

export type BulkUpdateAssigneeRequest = z.infer<
  typeof BulkUpdateAssigneeRequestSchema
>;

export const BulkUpdateAssigneeResponseSchema = z.object({
  updatedCount: z.number(),
  message: z.string(),
});

export type BulkUpdateAssigneeResponse = z.infer<
  typeof BulkUpdateAssigneeResponseSchema
>;
